  let questions = document.querySelectorAll(".questions");
  questions.forEach(questions => {
    questions.addEventListener("click", event => {
      const active = document.querySelector(".questions.active");
      if (active && active !== questions) {
        active.classList.toggle("active");
        active.nextElementSibling.style.maxHeight = 0;
      }
      questions.classList.toggle("active");
      const answers = questions.nextElementSibling;
      if (questions.classList.contains("active")) {
        answers.style.maxHeight = answers.scrollHeight + "px";
      } else {
        answers.style.maxHeight = 0;
      }
    })
  })


const content = document.getElementById('content-tabs');
const toggleButton = document.getElementById('toggleButton');

// Define translations
const translations = {
  en: {
    read_more: 'Read more',
    read_less: 'Read less'
  },
  nl: {
    read_more: 'Lees verder',
    read_less: 'Lees minder'
  },
  de: {
    read_more: 'Mehr lesen',
    read_less: 'Weniger lesen'
  }
};

// Detect the language, default to 'en' (English)
const language = document.documentElement.lang || 'en'; // You can replace this with your logic to detect the language

toggleButton.addEventListener('click', () => {
  if (content.style.maxHeight) {
    content.style.maxHeight = null;
    toggleButton.textContent = translations[language].read_more;
    content.classList.remove('active');
  } else {
    content.style.maxHeight = content.scrollHeight + 'px';
    toggleButton.textContent = translations[language].read_less;
    content.classList.add('active');
  }
});




function togglePopup(){
  document.getElementById("popup-1").classList.toggle("active");
}




var swiper = new Swiper(".custom-media-slider", {
  spaceBetween: 30,
  centeredSlides: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});